import React, { useState } from "react";
import {
  Grid,
  Paper,
  Typography,
  Box,
  CircularProgress,
  Alert,
  Autocomplete,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../context";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import MedicationAdministration from "./MedicationAdministration";

const API_BASE =
  (process.env.REACT_APP_API_URL || "").includes("undefined")
    ? "http://localhost:8000/api"
    : (process.env.REACT_APP_API_URL || "http://localhost:8000/api");
const MedicationsPage = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const token = auth?.user?.token || "";
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [patientSearch, setPatientSearch] = useState("");

  const {
    data: patientsData,
    isLoading: patientsLoading,
  } = useQuery({
    queryKey: ["nurse-patients"],
    queryFn: () =>
      axios
        .get(`${API_BASE}/nurse-patients/`, {
          headers: { Authorization: `Token ${token}` },
        })
        .then((res) => res.data),
    enabled: !!token,
  });

  const allPatients = [
    ...(patientsData?.ipd_patients || []),
    ...(patientsData?.icu_patients || []),
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2 }}>
          <Typography variant="h5" gutterBottom>
            {t("nurse.medicationAdministration", "Medication Administration")}
          </Typography>

          <Box sx={{ mb: 3 }}>
            <Autocomplete
              options={allPatients}
              getOptionLabel={(option) => option.patient_name || ""}
              value={selectedPatient}
              onChange={(event, newValue) => {
                setSelectedPatient(newValue);
              }}
              inputValue={patientSearch}
              onInputChange={(event, newInputValue) => {
                setPatientSearch(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("nurse.selectPatient", "Select Patient")}
                  placeholder={t("nurse.searchPatient", "Search patient...")}
                />
              )}
            />
          </Box>

          {selectedPatient && (
            <MedicationAdministration
              patient={{ id: selectedPatient.patient_id || selectedPatient.id }}
              encounter={null}
            />
          )}

          {!selectedPatient && (
            <Alert severity="info">
              {t("nurse.selectPatientForMedications", "Please select a patient to view medications.")}
            </Alert>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default MedicationsPage;

